import CheckoutForm from "@components/CheckoutForm"
import FunnelHeader from "@components/quiz/FunnelHeader"
import FunnelLayout from "@components/quiz/FunnelLayout"
import { parsePlan } from "@helpers/plans"
import { stripeAppearance } from "@helpers/stripeAppearance"
import useColorScheme from "@hooks/useColorScheme"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { User } from "@supabase/supabase-js"
import { useTranslation } from "react-i18next"
import {
  Navigate,
  useLoaderData,
  useNavigate,
  useSearchParams,
} from "react-router-dom"

const PLANS_PATH = "/checkout/plans"

const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string,
)

export default function PaymentPage() {
  const [searchParams] = useSearchParams()
  const loaderData = useLoaderData()
  const navigate = useNavigate()
  const { t } = useTranslation()
  // NOTE: Elements updates the card form when the appearance changes.
  const colorScheme = useColorScheme()

  const user = loaderData as User

  const clientSecret = searchParams.get("client_secret")!
  const currency = searchParams.get("currency")!
  const fullPrice = searchParams.get("full_price")!
  const nextPriceId = searchParams.get("next_price_id")!
  const plan = parsePlan(searchParams.get("plan"))
  const priceId = searchParams.get("price_id")!

  if (!clientSecret || !plan || !user)
    return <Navigate replace to={PLANS_PATH} />

  return (
    <FunnelLayout header={<FunnelHeader onBack={() => navigate(PLANS_PATH)} />}>
      <div className="flex flex-col gap-5 pb-10 pt-2">
        <h1 className="vm-heading animate-fade-up">
          {t("pages.checkout.paywall.payment.heading")}
        </h1>

        <Elements
          options={{
            appearance: stripeAppearance(colorScheme),
            clientSecret,
            fonts: [
              {
                cssSrc:
                  "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap",
              },
            ],
          }}
          stripe={stripePromise}
        >
          <CheckoutForm
            clientSecret={clientSecret}
            currency={currency}
            fullPrice={parseFloat(fullPrice)}
            plan={plan}
            stripeFirstPriceId={priceId}
            stripeNextPriceId={nextPriceId}
            userEmail={user.email}
          />
        </Elements>
      </div>
    </FunnelLayout>
  )
}
